import {QuestionDifficulty} from '@domain/pom'

export const POM_COMPLETION_WIDGET_NAMESPACE = 'widget.pom-completion'

export const DIFFICULTY_LABEL_KEY: Record<QuestionDifficulty, string> = {
  [QuestionDifficulty.Basic]: 'headings.basic',
  [QuestionDifficulty.Advanced]: 'headings.advanced',
  [QuestionDifficulty.Excellence]: 'headings.excellence'
}
